<ng-container *ngIf="element">
    <header *ngIf="showSliderHeader" class="slider-title">
        <render-wysiwyg
            *ngIf="element.settings.general.showSliderTitle && element.settings.general.sliderTitle?.length > 0"
            [html]="element.settings.general.sliderTitle"
        >
        </render-wysiwyg>

        <ng-container *ngIf="element.settings.general.arrowPosition === 'header-right'; then sliderArrows"></ng-container>
    </header>

    <div #sliceSliderWrapper class="slice-slider-wrapper" [ngClass]="{ 'swiper-freeMode': isScrollFree }">
        <ng-container *ngIf="isBrowser; else swiperSSR">
            <swiper
                #swiper
                class="swiper-container"
                *ngIf="slides?.length > 0"
                (activeIndexChange)="updateState()"
                (scrollbarDragEnd)="updateState()"
                (init)="resetSwiperAfterLazyImagesLoad()"
                [config]="config"
            >
                <ng-template *ngFor="let slide of slides; trackBy: trackByIndex; let i = index" swiperSlide>
                    <div [ngStyle]="i === 0 && { 'margin-left': initialOffset }">
                        <slot-manager
                            data-e2e="slot-manager"
                            [element]="slide"
                            [ngStyle]="slidesStyle[i]"
                            [direction]="direction"
                            [resolution]="resolution"
                        ></slot-manager>
                    </div>
                </ng-template>
            </swiper>
        </ng-container>

        <ng-template #swiperSSR>
            <div style="display: flex; overflow: auto">
                <ng-container *ngFor="let slide of slides; trackBy: trackByIndex; let i = index">
                    <div
                        [ngStyle]="{
                            '--number-of-slides': element.settings.general.numberOfSlides,
                            '--number-of-slides-mobile': element.settings.general.numberOfSlidesMobile,
                            'margin-left': i === 0 ? initialOffset : 0,
                            'margin-right': element.settings.general.spaceBetween ? element.settings.general.spaceBetween + 'px' : 0
                        }"
                        class="slides"
                        style="flex-shrink: 0"
                        [class.w-auto]="element.settings.general.numberOfSlides === 1 && element.settings.general.numberOfSlidesMobile === 1"
                    >
                        <slot-manager
                            data-e2e="slot-manager"
                            [element]="slide"
                            [ngStyle]="slidesStyle[i]"
                            [direction]="direction"
                            [resolution]="resolution"
                        ></slot-manager>
                    </div>
                </ng-container>
            </div>
        </ng-template>

        <ng-container *ngIf="element.settings.general.arrowPosition === 'inside-left-right'; then sliderArrows"></ng-container>

        <div class="swiper-pagination-count" *ngIf="element?.settings?.general?.pagination && this.isPagerStylecount">
            <button class="button-prev" (click)="arrowClick('prev')">
                <svg viewBox="0 0 11 16" fill="none">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z"
                    />
                </svg>
            </button>
            <div class="slides-count">
                <span>{{ currentIndex + 1 }}</span>
                <span>|</span>
                <span>{{ slots.length }}</span>
            </div>
            <button class="button-next" (click)="arrowClick('next')">
                <svg viewBox="0 0 11 16">
                    <path fill-rule="evenodd" clip-rulze="evenodd" d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
                </svg>
            </button>
        </div>
    </div>

    <ng-template #sliderArrows>
        <!-- Todo: Quitar la clase swiper-arrow-icon cuando se dejen de usar las flechas custom de la home 2022 -->
        <div
            class="arrow-control"
            [ngClass]="{
                'arrow-control-mm-vertical': swiperDirectionVer,
                'arrow-control-mm-horizontal': swiperDirectionHor,
                'swiper-arrow-icon': arrowIsIcon
            }"
            *ngIf="(arrowIsIcon || arrowIsCustomIcon || arrowIsTitle) && isScrollPager"
        >
            <div
                role="button"
                tabindex="0"
                aria-label="swiper arrow prev"
                (click)="arrowClick('prev')"
                class="swiper-arrow swiper-arrow-prev"
                [ngClass]="{
                    'swiper-button-disabled': disablePrevArrow
                }"
            >
                <svg *ngIf="arrowIsIcon" viewBox="0 0 11 16" fill="none">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z"
                    />
                </svg>
                <img *ngIf="arrowIsCustomIcon" alt="Anterior" [src]="arrowIsCustomIconPrev" />
                <render-wysiwyg *ngIf="arrowIsTitle" class="swiper-page-title" [html]="arrowIsTitleTextPrev"></render-wysiwyg>
            </div>
            <div
                role="button"
                tabindex="0"
                aria-label="swiper arrow next"
                (click)="arrowClick('next')"
                class="swiper-arrow swiper-arrow-next"
                [ngClass]="{ 'swiper-button-disabled': disableNextArrow }"
            >
                <svg *ngIf="arrowIsIcon" viewBox="0 0 11 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
                </svg>
                <img *ngIf="arrowIsCustomIcon" alt="Siguiente" [src]="arrowIsCustomIconNext" />
                <render-wysiwyg *ngIf="arrowIsTitle" class="swiper-page-title" [html]="arrowIsTitleTextNext"></render-wysiwyg>
            </div>
        </div>
    </ng-template>
</ng-container>
